/* eslint-env browser, amd */
(function() {
    'use strict';
    $('.card').click(
        function() {
            $('.card.hover').removeClass('hover');
            $(this).toggleClass('hover');
        });

    $('.card-hover').click(
        function(e) {
            e.preventDefault();
            var urlFiche = $(this).attr('data-redirect');
            window.location.href = urlFiche;
        });
})();



//////////////////
// WEBPACK FOOTER
// ./source/javascript/es5/flipcard.js
// module id = 10
// module chunks = 0